enum ConfirmationModalTypes {
  Regular = 'regular',
  Warning = 'warning',
  Danger = 'danger',
}

export default ConfirmationModalTypes
